import { GreyScale } from '@medly-components/theme';

const silverGrey: GreyScale = {
    50: '#FBFBFA',
    100: '#F2F1EF',
    200: '#ECEAE7',
    300: '#E3E1DC',
    400: '#DDDBD5',
    500: '#D5D2CB',
    600: '#C2BFB9',
    700: '#979590',
    800: '#757470',
    900: '#595855'
};

export default silverGrey;
